<link rel="ractive" href="../r-page.html">
<link rel="ractive" href="../components/header.html" name="c-header">
<link rel="ractive" href="../components/footer.html" name="c-footer">
<link rel="ractive" href="../components/landing-bottom.html" name="c-landing-bottom">
<link rel="ractive" href="../components/landing-top.html" name="c-landing-top">
<link rel="ractive" href="../components/notification.html" name="c-notification">
<link rel="ractive" href="../components/search.html" name="c-search">
<link rel="ractive" href="../components/header-gradient.html" name="c-header-gradient">

<r-page noYield="{{noYield}}" title="{{title}}" description="{{description}}">
	{{#partial seo}}
	<script type="application/ld+json">
		[
			{
				"@context": "http://schema.org",
				"@type": "Organization",
				"url": "https://www.jsdelivr.com/",
				"sameAs": [
					"https://www.linkedin.com/company/jsdelivr/",
					"https://twitter.com/jsdelivr",
					"https://en.wikipedia.org/wiki/JSDelivr"
				],
				"@id": "#organization",
				"name": "jsDelivr",
				"alternateName": "JSDelivr",
				"foundingDate": "2012-04-10",
				"logo": "https://www.jsdelivr.com/icon_256x256.png",
				"founders": [
					"Dmitriy Akulov"
				],
				"numberOfEmployees": "5"
			},
			{
				"@context": "https://schema.org",
				"@type": "WebSite",
				"url": "https://www.jsdelivr.com/",
				"potentialAction": {
					"@type": "SearchAction",
					"target": {
						"@type": "EntryPoint",
						"urlTemplate": "https://www.jsdelivr.com/?query={search_term_string}"
					},
					"query-input": "required name=search_term_string"
				}
			}
		]
	</script>
	{{/partial}}
	<c-notification></c-notification>
	<c-header></c-header>

	<div class="home">
		<c-header-gradient showMap="{{ true }}"></c-header-gradient>
		<div class="p-index page">
			<c-landing-top activeDocs="{{docs}}" ></c-landing-top>
			<c-search __ready="{{__ready}}" hideLanding="{{hideLanding}}" page="{{page}}" query="{{query}}" type="{{type}}" style="{{style}}" caretPosition="{{caretPosition}}"></c-search>
			{{#unless ~/hideLanding}}
			<c-landing-bottom></c-landing-bottom>
			{{/unless}}
		</div>

		<c-footer></c-footer>
	</div>
</r-page>

<script>
	component.exports = {
		oninit () {
			this.on('c-header.main-logo-click', () => {
				this.set('query', '');
				return false;
			});
		},
	};
</script>
